import { render, staticRenderFns } from "./SekuritasSaham.vue?vue&type=template&id=39ba6866&"
import script from "./SekuritasSaham.vue?vue&type=script&lang=js&"
export * from "./SekuritasSaham.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports